import styled from '@emotion/styled';
import { ITheme, Responsive, RowRole } from '../../../../../ui';
import { Color } from '../../../../../styles/Color';
import * as ProposerName from './columns/ProposerName';
import * as ProposerCompany from './columns/ProposerCompany';
import * as ProposerDbeMwbe from './columns/ProposerDbeMwbe';
import * as ProposerEmail from './columns/ProposerEmail';
import * as ProposerPhone from './columns/ProposerPhone';

const StyledRow = styled(RowRole)<{}, ITheme>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid ${Color.BorderCard};
	font-size: ${({ theme }) => theme.typography?.small?.size};
	font-weight: 400;
	color: ${({ theme }) => theme.color?.text?.light};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: none;
	}
`;

export function SolicitationProposersListHeader() {
	return (
		<StyledRow>
			<ProposerName.Header />

			<ProposerCompany.Header />

			<ProposerDbeMwbe.Header />

			<ProposerEmail.Header />

			<ProposerPhone.Header />
		</StyledRow>
	);
}
